import isNil from "lodash-es/isNil";
import posthogStore from "../stores/posthogStore";
import { ensureWretchError } from "./apiClient";

// Login sends the username and password in the query string, so URLs are only reported without it
export const stripQueryString = (url: string): string => url.split("?")[0];

/**
 * Reports a handled error to PostHog error tracking. Errors from failed requests also get the response status and URL.
 */
export const reportError = (error: unknown, properties: Record<string, unknown> = {}) => {
   const wretchError = isNil(error) ? null : ensureWretchError(error);
   const response = wretchError?.response;
   const requestProperties = response ? { http_status: response.status, request_url: stripQueryString(response.url) } : {};

   posthogStore.posthog?.captureException(error, { ...properties, ...requestProperties });
};
